<template>
  <main class="l-main p-tasklist">
    <TitleMain icon="tasklist" howTo="/sections/4404626251407">
      <span class="title">タスクリスト</span>
      <span class="description"
        >検討した施策やサイト改善案、気づきなどをタスク化して、一覧で管理しましょう。</span
      >
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <ul class="c-tab--balloon l-mb-4">
        <li class="c-tab--balloon__item">
          <router-link
            :to="{
              name: 'taskList'
            }"
            class="c-tab--balloon__link"
            exact
          >
            <Icon2 variant="pen" :size="20" />
            登録したタスクリスト
          </router-link>
        </li>
        <li class="c-tab--balloon__item">
          <router-link
            :to="{
              name: 'taskListProposals'
            }"
            class="c-tab--balloon__link"
            exact
          >
            <Icon2 variant="hint" :size="26" />
            自動抽出した改善提案リスト
          </router-link>
        </li>
      </ul>
      <router-view :project="project" />
    </div>
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import ButtonToProjects from '@/components/ButtonToProjects';
import Icon2 from '@/components/Icon2';
import TitleMain from '@/components/TitleMain';

export default {
  props: ['project'],
  components: {
    Breadcrumb,
    ButtonToProjects,
    Icon2,
    TitleMain
  }
};
</script>
